(function () {
  'use strict';

  function tokenSeason(token) {
    var word = token.toLowerCase();
    if (word === '通常タイヤ') return 'regular';
    if (['冬タイヤ', 'スタッドレス', '冬', 'winter', 'studless'].indexOf(word) !== -1) return 'winter';
    return '';
  }

  function querySeasons(value) {
    var seasons = { regular: false, winter: false };
    value.split(/\s+/).forEach(function (token) {
      var season = tokenSeason(token);
      if (season) seasons[season] = true;
    });
    return seasons;
  }

  function withoutSeason(value, selected) {
    return value.split(/\s+/).filter(function (token) {
      return token && tokenSeason(token) !== selected;
    }).join(' ');
  }

  function initializeFinders() {
    document.querySelectorAll('[data-catalog-finder]').forEach(function (form) {
      if (form.dataset.catalogReady === 'true') return;
      var input = form.querySelector('[name="q"]');
      var select = form.querySelector('[data-catalog-season]');
      var field = form.querySelector('[data-catalog-season-field]');
      if (!input || !select) return;

      form.dataset.catalogReady = 'true';
      var initial = input.value.normalize('NFKC').trim();
      var initialSeasons = querySeasons(initial);
      if (initialSeasons.regular !== initialSeasons.winter) {
        select.value = initialSeasons.regular ? 'regular' : 'winter';
        input.value = withoutSeason(initial, select.value);
      } else {
        input.value = initial;
      }
      select.hidden = false;
      select.disabled = false;
      if (field) field.hidden = false;
      var lastSubmission = null;

      form.addEventListener('submit', function (event) {
        var inputValue = input.value.normalize('NFKC').trim();
        if (lastSubmission && inputValue === lastSubmission.query) inputValue = lastSubmission.input;
        var explicitInput = inputValue;
        var size = select.value === 'all' ? inputValue : withoutSeason(inputValue, select.value);
        var season = select.value === 'winter' ? '冬タイヤ' : select.value === 'regular' ? '通常タイヤ' : '';
        if (!size && !season) {
          event.preventDefault();
          window.location.assign(form.dataset.allUrl || '/collections/all');
          return;
        }
        input.value = [season, size].filter(Boolean).join(' ');
        lastSubmission = { input: explicitInput, query: input.value };
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFinders, { once: true });
  } else {
    initializeFinders();
  }
  document.addEventListener('shopify:section:load', initializeFinders);
}());
